module.exports = __webpack_public_path__ + "img/brand-icon9.fb91e262.jpg";